import type { RouteLocationNormalized } from 'vue-router'
import { i18n } from '@/i18n'
import { useTenantBrandingStore } from '@/stores/tenant-branding'
import { applyAdminSeoMeta, buildAdminDocumentTitle } from '@/utils/admin-seo'

export interface BreadcrumbMetaItem {
  labelKey: string
  path?: string
}

/**
 * Sets document.title from route meta (titleKey or last breadcrumb) plus tenant / app suffix.
 */
export function syncDocumentTitle(to: RouteLocationNormalized): void {
  const titleKey = to.meta.titleKey as string | undefined
  const breadcrumbs = to.meta.breadcrumbs as BreadcrumbMetaItem[] | undefined

  let page = ''
  if (titleKey) {
    page = String(i18n.global.t(titleKey))
  } else if (breadcrumbs?.length) {
    page = String(i18n.global.t(breadcrumbs[breadcrumbs.length - 1].labelKey))
  }

  const branding = useTenantBrandingStore().branding
  const title = buildAdminDocumentTitle(branding, page)
  document.title = title
  applyAdminSeoMeta(branding, title)
}
